import script from "./bi-tmpl-detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./bi-tmpl-detail.vue?vue&type=script&lang=ts&setup=true"

import "./bi-tmpl-detail.vue?vue&type=style&index=0&id=07ebaeb1&lang=scss"
import "./bi-tmpl-detail.vue?vue&type=style&index=1&id=07ebaeb1&lang=scss"
import "./bi-tmpl-detail.vue?vue&type=style&index=2&id=07ebaeb1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07ebaeb1"]])

export default __exports__